







































import Vue from 'vue';
import { ListModel, ListHeaderModel, CabinetModel } from '@/types';
import MStoreFormSelectTable from '@/components/shared/MStoreFormSelectTable.vue';
import { ValidationModel } from '@/types/models/validation';

export default Vue.extend({
  name: 'MStoreDocumentTypeSelect',
  props: {
    value: {
      required: true
    },
    required: {
      default: false,
      type: Boolean
    },
    isReadonly: {
      default: false,
      type: Boolean
    },
    formId: {
      required: false,
      type: String
    },
    id: {
      default: 'documentTypeSelect',
      type: String
    },
    excludeCabinetWithNoDocumentType: {
      default: false,
      type: Boolean
    },
    cabinetLabel: {
      default: 'Cabinet',
      type: String
    },
    documentTypeLabel: {
      default: 'Document Type',
      type: String
    },
    items: {
      required: true,
      type: Array
    },
    isLoading: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      selectedCabinet: null
    };
  },
  computed: {
    htmlElementId(this: any) {
      return this.formId ? `${this.formId}.${this.id}` : this.id;
    },
    htmlElementIdCabinet(this: any) {
      return `${this.htmlElementId}_cabinet`;
    },
    htmlElementIdDocumentType(this: any) {
      return `${this.htmlElementId}_documentType`;
    },
    cabinetList(this: any): ListModel {
      return this.cabinetWithDocumentTypes?.length > 0
        ? {
            id: 0,
            text: this.cabinetLabel,
            key: this.properties.cabinet.displayField,
            headers: this.fields.cabinet as ListHeaderModel[],
            list: this.sort(this.cabinetWithDocumentTypes, this.properties.cabinet.displayField),
            totalRow: this.cabinetWithDocumentTypes.length,
            resultType: 1,
            listDataResultTypeMessage: ''
          }
        : ({} as ListModel);
    },
    documentTypeList(this: any): ListModel {
      const cabinet = this.cabinetWithDocumentTypes?.find((cabinet: any) => cabinet.id === this.selectedCabinet);
      return cabinet?.documentTypes?.length > 0
        ? {
            id: 0,
            text: this.documentTypeLabel,
            key: this.properties.documentType.displayField,
            headers: this.fields.documentType as ListHeaderModel[],
            list: this.sort(cabinet.documentTypes, this.properties.documentType.displayField),
            totalRow: cabinet?.documentTypes?.length,
            resultType: 1,
            listDataResultTypeMessage: ''
          }
        : ({} as ListModel);
    },
    inputValue: {
      get(this: any) {
        return this.value;
      },
      set(this: any, value: string) {
        this.$emit('input', value);
      }
    },
    cabinetWithDocumentTypes(this: any) {
      return this.excludeCabinetWithNoDocumentType ? this.items.filter((cabinet: CabinetModel) => cabinet?.documentTypes?.length > 0) : this.items;
    },
    isDisabled(this: any): boolean {
      return this.isReadonly || this.isLoading;
    },
    validationModel(): ValidationModel {
      return { required: this.required } as ValidationModel;
    }
  },
  methods: {
    onCabinetChange(this: any, value: any) {
      this.selectedCabinet = value;
      this.inputValue = null;
      this.$emit('update:cabinet', value);
    },
    prepareDefaultValue(this: any) {
      const cabinet = this.cabinetWithDocumentTypes.find((cabinet: any) => cabinet.documentTypes.some((documentType: any) => documentType.id === this.value));
      if (!cabinet) {
        this.inputValue = null;
      }
      this.selectedCabinet = cabinet?.id;
    },
    sort(this: any, list: any[], key: string): any[] {
      return list.sort((item1: any, item2: any) => (item1[key]?.toLowerCase() > item2[key]?.toLowerCase() ? 1 : -1));
    },
    setFocusToDocumentTypeForSelection(this: any) {
      this.$nextTick(() => this.$refs.documentType.setFocusForSelection());
    }
  },
  watch: {
    items(this: any) {
      this.prepareDefaultValue();
    }
  },
  created(this: any) {
    this.properties = {
      cabinet: {
        actionButtonComponent: '',
        maxLength: 0,
        filterEnabled: true,
        displayField: 'description',
        valueField: 'id'
      },
      documentType: {
        actionButtonComponent: '',
        maxLength: 0,
        filterEnabled: true,
        displayField: 'description',
        valueField: 'id'
      }
    };
    this.fields = {
      cabinet: [
        {
          id: '',
          data: 'description',
          title: 'Cabinet',
          key: 'id',
          label: 'description'
        }
      ],
      documentType: [
        {
          id: '',
          data: 'description',
          title: 'Document Type',
          key: 'id',
          label: 'description'
        }
      ]
    };
  },
  components: {
    MStoreFormSelectTable
  }
});
